export default "__VITE_ASSET__f29739fb__"